import React, { useState } from "react"
import PracticalCardItem from "./practical-card-item"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import useWindowWidth from "../../hooks/useWindowWidth"

function PracticalCardContainer({ header, lineTwoHeader, subHeader, practicalCardBlockItems, topPadding, bottomPadding }) {
  //state
  const [areCardsClosed, setAreCardsClosed] = useState(true) //trigger for
  const [activeCard, setActiveCard] = useState(null) //index value
  const [maximumCardTitleHeightValue, setMaximumCardTitleHeightValue] = useState(0)
  const windowWidth = useWindowWidth()
  const tPadding = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding, false) || undefined
  const bPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding, false) || undefined

  const htmlCardElements = practicalCardBlockItems.map((card, index) => {
    return (
      <PracticalCardItem
        key={card.cardTitle}
        elementId={card.cardTitle}
        setAreCardsClosed={setAreCardsClosed}
        areCardsClosed={areCardsClosed}
        setActiveCard={setActiveCard}
        activeCard={activeCard}
        activateSplash={card.activateSplash}
        portraitPhoto={card.cardPortraitPhoto}
        splashLabel={card.cardSplashLabel}
        title={card.cardTitle}
        readMore={card.cardReadMore}
        readLess={card.cardReadLess}
        header={card.innerCardHeader}
        introText={card.innerIntroCardText}
        introImage={card.innerIntroImage}
        innerVideo={card.innerVideo}
        youtubeID={card.youtubeID}
        thumbnailImage={card.thumbnailImage}
        ariaDescription={card.ariaDescription}
        explainerText={card.innerIntroImageExplainerText}
        introImageUrl={card.innerIntroImageUrl} //An anchor link pointing elsewhere on the site.
        introImageUrlLabel={card.innerIntroImageUrlLabel}
        additionalImageSections={card.additionalImageSections}
        outroText={card.innerOutroCardText}
        windowWidth={windowWidth}
        maximumCardTitleHeightValue={maximumCardTitleHeightValue}
        setMaximumCardTitleHeightValue={setMaximumCardTitleHeightValue}
      />
    )
  })

  const mobileHeaderhtml = ReactHtmlParser(`<h2>${!lineTwoHeader ? header : header + "<br/>" + lineTwoHeader}</h2>`)
  const desktopHeaderhtml = ReactHtmlParser(`<h2>${!lineTwoHeader ? header : header + " " + lineTwoHeader}</h2>`)

  return (
    <div className={`practical-card-block ${tPadding} ${bPadding}`}>
      <div className="w--normal">
        {windowWidth > 750 ? desktopHeaderhtml : mobileHeaderhtml}
        <h3>{subHeader}</h3>
        <div className={`cards ${areCardsClosed ? "no-actives" : ""} ${practicalCardBlockItems.length === 2 ? "two-cards" : ""}`}>
          {htmlCardElements}
        </div>
      </div>
    </div>
  )
}

export default PracticalCardContainer
